import { CheckIcon, PencilSquareIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { useState } from 'react'
import { toast } from 'react-toastify'

type EditableOriginTitleProps = {
  value: string
  onUpdate: (nextTitle: string) => void
}

export const EditableOriginTitle = ({ value, onUpdate }: EditableOriginTitleProps) => {
  const [draft, setDraft] = useState<string | null>(null)

  const startEdit = () => setDraft(value)

  const cancel = () => setDraft(null)

  const confirm = () => {
    if (draft === null) return
    const next = draft.trim()
    if (!next) {
      toast('Title is required', { type: 'warning' })
      return
    }
    onUpdate(next)
    setDraft(null)
  }

  if (draft !== null) {
    return (
      <>
        <input
          className="w-60 border-black border-2 rounded-md px-2"
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
        />
        <span className="text-red-600 cursor-pointer hover-shadow1 p-1 rounded" onClick={cancel}>
          <XMarkIcon className="w-4 h-4" />
        </span>
        <span className="btn-icon" onClick={confirm}>
          <CheckIcon className="w-4 h-4" />
        </span>
      </>
    )
  }

  return (
    <p className="flex items-center gap-2">
      {value}
      <span className="btn-icon" onClick={startEdit}>
        <PencilSquareIcon className="w-4 h-4" />
      </span>
    </p>
  )
}
